import { Component, h } from 'preact'
import ButtonControl from '../button-control'
import Content from '../common/Content'
import UserAvatar from '../User/UserAvatar'
import formatDateInLocalTimezone from '../utils/dateFormatting'
import { Reply } from './interfaces'
import Axios from 'axios'
import PostEditor from '../editor/postEditorViaAPI'
import Icon from "../assets";
import classNames from 'classnames'
import tracker from "../../components/tracker/publish";
import {isIdea} from "../utils/contentType";

interface Props extends Reply {
  topicType: 'productUpdate' | 'idea',
  isAuthor?: boolean,
  isPinned?: boolean,
  replyNumber?: number,
  replyCount?: number,
  topicId: number,
  topicPublicId: string,
  onTogglePin: (pinnedReplyId: string | null) => void,
}

interface State extends Reply {
  topicType: 'productUpdate' | 'idea',
  showEditor?: boolean,
  isAuthor?: boolean,
  isPinned?: boolean,
  replyNumber?: number,
  replyCount?: number
}

class Post extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    const likedByOpener = this.props.likedBy.includes(String(window.inSidedData.user.userid))
    this.state = {
      ...props,
      showEditor: false,
      likedByOpener: likedByOpener
    }
    this.onTrash = this.onTrash.bind(this)
  }

  async onTrash () {
    const setTrashed = async (trashed: boolean) => {
      await Axios.post(`/community/api/${this.props.topicType}s/replies/${this.state.id}/toggleTrashed`, {
        trashed
      }).then(() => {
        this.setState({ trashed })
      })
    }

    await setTrashed(!this.state.trashed)
  }

  onTogglePin = async () => {
    const { id } = this.state
    const {topicPublicId, topicType, isPinned } = this.props

    if (!isIdea(topicType)) return

    const action = isPinned ? 'unpin' : 'pin'

    await Axios.post(`/community/api/${this.props.topicType}s/replies/${id}/${action}`)
        .then(() => this.setState(({ isPinned }) => ({ isPinned: ! isPinned })))
        .then(() => this.props.onTogglePin(isPinned ? null : id))
        .then(() => tracker.trackEvent('userevent', {
          'type': `Reply ${isPinned ? 'Unpinned' : 'Pinned'}`,
          'reply_id': id,
          'topic_content_type': topicType,
          'topic_id': topicPublicId
        }))
  }

  onToggleLike = async () => {
    const {id} = this.state
    const action = this.state.likedByOpener ? 'unlike' : 'like'
    await Axios.post(`/community/api/${this.props.topicType}s/replies/${id}/${action}`)
        .then(() => {
              const userId = String(window.inSidedData.user.userid)
              if (this.state.likedByOpener) {
                this.setState({likedBy: this.state.likedBy.filter(e => e !== userId), likedByOpener: false})
              } else {
                let likedBy = this.state.likedBy
                likedBy.push(userId)
                this.setState({likedBy: likedBy, likedByOpener: true})
              }
            }
        )
  }

  render ({ id, author, repliedAt, isAuthor = false, replyNumber, replyCount, topicType, topicId, isPinned = false, likedBy}: Props, { trashed, content, showEditor }: State) {
    return (
      <article id={`post-${id}`} className={classNames(
          'post', 'panel', 'panel-default',
          {
            'status--trashed': trashed,
            'status--pin': isPinned,
          }
      )}>
        <div className='post--inner-wrapper'>
          <div className='panel-body'>
            <div className='user-avatar--container clearfix'>
              <UserAvatar
                user={{ ...author, ...{ name: author.username }, ...{ url: `/member/profile/?userid=${author.id}` } }}
                extraClass='avatar avatar--L'
                style={{ float: 'left' }}
                showRank
                openInNewTab
              />
              <div className='user-avatar--info'>
                <h4>
                  <strong>
                    <a href={`/member/profile/?userid=${author.id}`}>{author.username}</a>
                  </strong>
                </h4>
                <span className='text-muted posts-count clearfix'>{author.reputation.repliesMade} replies</span>
              </div>
            </div>
            <div className='post--content-container'>
              <header className='clearfix'>
                <span className='text-muted post--time'>
              Posted on {formatDateInLocalTimezone(new Date(repliedAt).getTime() / 1000)}
                </span>
                <div className='pull-right pill-container'>
                  {trashed && <span className='pill pill--trashed'>trashed</span>}
                  {isPinned && !trashed && <span className='pill pill--pin'>pin</span>}
                  {isAuthor && !trashed && <span className='pill pill--author'>author</span>}
                  <span className='pill pill--counter'>{replyNumber} of {replyCount}</span>
                </div>
              </header>
              <div className='post--content post--content-new-editor'>
                {
                  showEditor ? (
                    <PostEditor
                      replyId={Number(id)}
                      topicId={topicId}
                      isControl
                      data={content}
                      onSuccess={(content: string) => this.setState({ showEditor: false, content })}
                      onCancel={() => { this.setState({ showEditor: false }) }}
                      type={`${topicType}s` as 'productUpdates' | 'ideas'}
                      redirect={false}
                      isGuest={false}
                      disableFileAttachments={false}
                    />
                  ) : (
                    <Content
                      content={content || ''}
                      className='qa-post-content'
                      isControl
                    />
                  )
                }
              </div>
              <footer className='post--options-list'>
                <div class='post--options-list-container'>
                  {isIdea(topicType) &&
                  <div class='post--options-list-container-item'>
                    <a className='post--options-icon' onClick={this.onTogglePin}>
                      <Icon icon='pin' width={16} height={16}/>
                      {isPinned ? 'Unpin reply' : 'Pin reply'}
                    </a></div>}
                  <div class='post--options-list-container-item'>
                    <a className={this.state.likedByOpener ? 'active' : ''} onClick={this.onToggleLike}>
                      <i className='fa fa-thumbs-up'/> Like ({this.state.likedBy.length})
                    </a>
                  </div>
                </div>
              </footer>
            </div>
          </div>
          <div className='post__panel-footer clearfix'>
            <div />
            <div className='post__panel-footer--action-box js-post-panel-footer-action-box'>
              <ButtonControl
                title='Edit post'
                variant='secondary'
                disabled={trashed}
                onClick={() => { this.setState({ showEditor: true }) }}
              />
              <ButtonControl
                title={trashed ? 'Restore' : 'Trash'}
                variant={trashed ? 'secondary' : 'warning'}
                onClick={this.onTrash}
              />
            </div>
          </div>
        </div>
      </article>
    )
  }
}

export default Post
